module.exports = __webpack_public_path__ + "img/hologram.02546aa3.png";